<template>
  <b-container>
    <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
    <b-alert
      :show="showDismissibleAlert"
      dismissible
      @dismissed="showDismissibleAlert=false"
      :variant="variant"
    >{{alertText}}</b-alert>
    <b-form @submit="onSubmit" @reset="onReset" v-if="show">
      <b-row>
        <b-col md="6" sm="12" class="mt-2 pb-4">
          <p class="reg-heading-tab">Shareholder Details</p>
          <p></p>
          <div class="reg-tab-container">
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Full Name*"
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-input
                    type="text"
                    required
                    size="sm"
                    placeholder="First Name"
                    style="width:130px"
                    v-model="form.ShareholderFirstName"
                    :formatter="format"
                    lazy-formatter
                  ></b-form-input>
                </b-input-group-prepend>

                <b-form-input
                  type="text"
                  placeholder="Middle Name"
                  size="sm"
                  required
                  v-model="form.ShareholderMiddleName"
                  :formatter="format"
                  lazy-formatter
                  style="width:75px"
                ></b-form-input>

                <b-input-group-append>
                  <b-form-input
                    type="text"
                    required
                    placeholder="Last Name"
                    size="sm"
                    style="width:130px"
                    v-model="form.ShareHolderLastName"
                    :formatter="format"
                    lazy-formatter
                  ></b-form-input>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group id="grpAddress" horizontal label-size="sm" label="Address*">
              <b-form-input
                id="exampleInput2"
                type="text"
                :formatter="format"
                lazy-formatter
                v-model="form.ShareholderAddress"
                required
                size="sm"
                placeholder="Address"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Status*"
              label-size="sm"
              label-for="exampleInput2"
            >
              <b-form-input
                id="exampleInput2"
                type="text"
                v-model="form.Status"
                required
                size="sm"
                placeholder="Status"
              ></b-form-input>
            </b-form-group>
          </div>
        </b-col>
        <b-col md="6" sm="12" class="mt-2">
          <p>
            <span class="reg-heading-tab">Other Details</span>
          </p>

          <div class="reg-tab-container">
            <b-form-group
              id="exampleInputGroup3"
              horizontal
              label="Birth Date*"
              label-size="sm"
              label-for="exampleInput3"
            >
              <date-picker v-model="DOB" format="DD-MM-YYYY" lang="en" required size="small"></date-picker>
            </b-form-group>

            <b-form-group
              id="exampleInputGroup2"
              horizontal
              label="Gender*"
              label-size="sm"
              label-for="radiosg"
            >
              <b-form-radio-group id="radiosg" v-model="form.ShareholderGender">
                <b-form-radio value="0">Female</b-form-radio>
                <b-form-radio value="1">Male</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
            <b-form-group
              id="exampleInputGroup1"
              horizontal
              label="Adhar Card No."
              label-size="sm"
              label-for="exampleInput1"
            >
              <b-form-input
                type="text"
                :formatter="format"
                lazy-formatter
                size="sm"
                :state="validateAadhar"
                v-model="form.ShareHolderAadhar"
                placeholder="Aadhar Number 12 digit"
              ></b-form-input>
            </b-form-group>
            <!-- <b-form-group id="exampleInputGroup2" horizontal
                            label="Pancard No." label-size="sm"
                            label-for="exampleInput2">
                        <b-form-input type="text" 
                                size="sm" :formatter="format" lazy-formatter
                                v-model="form.PanCardNo" :state="validatePan"
                                placeholder="PAN 10 digit"></b-form-input>    
            </b-form-group>-->
          </div>
        </b-col>
      </b-row>

      <b-row class="mt-2" v-if="!form.LockProfile">
        <b-col style="text-align:center">
          <Spinner size="32" message="Loading..." v-if="isLoading"></Spinner>
          <b-alert
            :show="showDismissibleAlert"
            dismissible
            @dismissed="showDismissibleAlert=false"
            :variant="variant"
          >{{alertText}}</b-alert>
        </b-col>
        <b-col style="text-align:right" class="button-wrap">
          <b-button type="submit" variant="primary">Submit</b-button>
          <b-button type="reset" variant="danger">Reset</b-button>
          <b-button variant="secondary" @click="onClickButton" v-if="saved">Next</b-button>
        </b-col>
      </b-row>
    </b-form>
    <div class="mt-2 reg-details-wrap">
      <p class="reg-heading-tab">Shareholder Details</p>
      <b-row align-h="center">
        <b-col>
          <b-table
            show-empty
            head-variant="dark"
            stacked="md"
            bordered
            striped
            :items="directors"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            style="font-size:12px"
          >
            <template v-slot:cell(ShareholderGender)="row">{{row.value?'Male':'Female'}}</template>
            <template v-slot:cell(actions)="row">
              <b-button
                size="sm"
                @click.stop="editMember(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="link"
                v-b-tooltip.hover
                title="Edit Member"
                v-if="!LockProfile"
              >
                <i class="fa fa-edit" style="font-size:16px;color:blue"></i>
              </b-button>
              <b-button
                size="sm"
                @click.stop="deleteMember(row.item, row.index, $event.target)"
                class="mr-1 pt-0 pb-0"
                variant="link"
                v-b-tooltip.hover
                title="Delete Member"
                v-if="!LockProfile"
              >
                <i class="fa fa-trash" style="font-size:16px;color:red"></i>
              </b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </div>
    <b-modal id="modalConfirm" title="Are you sure?" size="sm">
      <pre>{{ modalInfo }}</pre>
      <div slot="modal-footer">
        <b-button variant="danger" @click="modalConfirm" style="margin-left:5px">Delete</b-button>
        <b-button variant="info" @click="modalCancel" style="margin-left:5px">Cancel</b-button>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import Formatter from "@/Formatter.js";
var _currentDate = new Date();
export default {
  name: "ShareHolders",
  components: { Spinner, DatePicker },
  data() {
    return {
      DOB: null,
      currentDate: _currentDate,
      form: {
        GroupShareholerID: "00000000-0000-0000-0000-000000000000",
        ShareholderFirstName: "",
        ShareholderMiddleName: "",
        ShareHolderLastName: "",
        ShareHolderAadhar: "",
        ShareholderAddress: "",
        ShareholderDOB: null,
        ShareholderGender: "0",
        Status: "",
        GroupID: "00000000-0000-0000-0000-000000000000"
      },
      directors: [],
      fields: [
        { key: "ShareholderFirstName", label: "First Name", sortable: true },
        { key: "ShareholderMiddleName", label: "Middle", sortable: true },
        { key: "ShareHolderLastName", label: "Last Name", sortable: true },
        { key: "ShareHolderAadhar", label: "Aadhar", sortable: true },
        { key: "ShareholderAddress", label: "Address", sortable: false },
        { key: "ShareholderDOB", label: "DOB", sortable: true },
        { key: "ShareholderGender", label: "Gender", sortable: true },
        { key: "Status", label: "Status", sortable: true },
        { key: "actions", label: "Edit" }
      ],
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      show: true,
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 20, 50],
      sortBy: null,
      sortDesc: false,
      filter: null,
      modalInfo: "",
      selectedNomineeId: "",
      saved: false
    };
  },
  computed: {
    LockProfile() {
      let userinfo = this.$store.getters.getUserData;
      if (userinfo) {
        return userinfo.LockProfile;
      } else {
        return false;
      }
    },
    validateAadhar() {
      if (this.form.ShareHolderAadhar == null) {
        return false;
      }

      if (this.form.ShareHolderAadhar.length == 0) {
        return false;
      } else if (this.form.ShareHolderAadhar != null) {
        var adharformat = /^\d{12}$/;
        if (this.form.ShareHolderAadhar.match(adharformat)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  },
  methods: {
    format(value, event) {
      if (value) {
        return value.trim();
      }
    },
    onClickButton() {
      this.saved = false;
      this.showDismissibleAlert = false;
      this.$emit("clicked");
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isLoading = true;
      //var userinfo = this.$store.getters.loggedUser;
      this.form.GroupID = this.$store.getters.getGroupId;
      this.form.ShareholderDOB = Formatter.convertDateFormatYMD(this.DOB);
      let promise = apis.saveShareholder(this.form);

      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.alertText = "Data Saved Successfully";
            this.getDirectors();
            this.onReset();
            this.saved = true;
            this.variant = "success";
            this.showDismissibleAlert = true;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch(err => {
          this.alertText = err.message || "Error while Saving Data";
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },
    onReset() {
      this.form.ShareholderFirstName = "";
      this.form.ShareholderMiddleName = "";
      this.form.ShareHolderLastName = "";
      this.form.ShareHolderAadhar = "";
      this.form.ShareholderAddress = "";
      this.form.ShareholderDOB = "";
      this.form.ShareholderGender = "0";
      this.form.Status = "";
      this.form.GroupShareholerID = "00000000-0000-0000-0000-000000000000";
      this.form.GroupID = "00000000-0000-0000-0000-000000000000";
    },
    editMember(item, index, target) {
      this.form.ShareholderFirstName = item.ShareholderFirstName;
      this.form.ShareholderMiddleName = item.ShareholderMiddleName;
      this.form.ShareHolderLastName = item.ShareHolderLastName;
      this.form.ShareHolderAadhar = item.ShareHolderAadhar;
      this.form.ShareholderAddress = item.ShareholderAddress;
      this.form.ShareholderDOB = item.ShareholderDOB;
      this.form.ShareholderGender = item.ShareholderGender;
      this.form.Status = item.Status;
      this.form.GroupShareholerID = item.GroupShareholerID;
    },
    getDirectors() {
      var userinfo = this.$store.getters.getGroupId;
      let promise = apis.ReadShareholder(userinfo);

      promise
        .then(response => {
          //console.log('Nominee Reponse' ,response);
          if (response.status == 200) {
            this.directors = response.body;
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch(err => {
          this.alertText = err.message || "Error while getting the details";
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    //Delte Family Member post confirmation

    deleteMember(item, index, button) {
      var userinfo = this.$store.getters.loggedUser;
      this.form.ShareholderFirstName = item.ShareholderFirstName;
      this.form.ShareholderMiddleName = item.ShareholderMiddleName;
      this.form.ShareHolderLastName = item.ShareHolderLastName;
      this.form.ShareHolderAadhar = item.ShareHolderAadhar;
      this.form.ShareholderAddress = item.ShareholderAddress;
      this.form.ShareholderDOB = item.ShareholderDOB;
      this.form.ShareholderGender = item.ShareholderGender;
      this.form.Status = item.Status;
      this.form.DirectorEmail = item.DirectorEmail;
      this.form.GroupShareholerID = item.GroupShareholerID;

      let info =
        "You want to delete record for:" + "\n" + item.ShareholderFirstName;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.onReset();
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      //let promise = apis.deleteFamilyMember(this.form);
      let promise = apis.deleteShareholder(this.form.GroupShareholerID);

      promise
        .then(response => {
          if (response.status == 200) {
            this.alertText = "Record removed Successfully.";
            this.onReset();
            this.getDirectors();
            this.showDismissibleAlert = true;
            this.variant = "success";
            this.isLoading = false;
          } else {
            this.alertText = response.body;
            this.showDismissibleAlert = true;
            this.variant = "warning";
          }
        })
        .catch(err => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    }
  },
  mounted() {
    if (this.$store.getters.isLoggedIn) {
      this.getDirectors();
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/RegistrationLoan/Shareholders.vue